

























import LoginContainer from '@/components/authentication/login-container/LoginContainer.component'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {AuthenticationRequest, PasswordType, PortalType} from '@payroll/optimus-common'
import Component from 'vue-class-component'
import {Action, Getter, Mutation} from 'vuex-class'
import FeedbackComponent from '../../base/FeedbackComponent'

@Component({
        components: {
            LoginContainer
        }
    })
    export default class BackOfficeLoginComponent extends FeedbackComponent {

        private loginAuth: AuthenticationRequest = {} as AuthenticationRequest

        private authenticationFormRadios: any[] = [];

        public loginType: string = 'viasms';

        @Action('authenticateWithPassword', StoreNamespace.AUTHENTICATION) authenticateWithPassword: any
        @Mutation('setIdNumber', StoreNamespace.AUTHENTICATION) setIdNumber: any
        @Mutation('setPhoneNum', StoreNamespace.AUTHENTICATION) setPhoneNum: any
        @Mutation('setEmail', StoreNamespace.AUTHENTICATION) setEmail: any
        @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string

        mounted() {
          this.loginAuth.portalType = PortalType.BACKOFFICE

          this.authenticationFormRadios = [{
            name: "authentication",
            value: "viasms",
            label: "SMS"
          }, {
            name: "authentication",
            value: "viaemail",
            label: this.$t('email_label').toString()
          }]
        }

        onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {

          this.setIdNumber(this.loginAuth.idNumber)

          if (data.phoneNum) {
            this.setEmail('')
            this.setPhoneNum(data.phoneNum);
            this.$router.push({
              name: 'viasms', params: {
                password: this.loginAuth.password,
                siteUrl: this.loginAuth.siteUrl,
                browserInfo: this.loginAuth.browserInfo
              }
            })
          }else if (data.email) {
            this.setPhoneNum('')
            this.setEmail(data.email)
            this.$router.push({
              name: 'viasms', params: {
                password: this.loginAuth.password,
                siteUrl: this.loginAuth.siteUrl,
                browserInfo: this.loginAuth.browserInfo
              }
            })
          }
        }

        onLogin() {
            this.loginAuth.passwordType = PasswordType.PASSWORD;
            this.loginAuth.extraAuthenticationType = this.loginType === 'viasms' ? PasswordType.SMS_CODE : PasswordType.EMAIL_CODE;
``

            this.authenticateWithPassword({
                requestBody: this.loginAuth,
                requestorCallback: this
            });
        }

      public onLoginTypeChange(newVal: any) {
        this.loginType = newVal;
      }
    }
